import { IOptionType } from 'interfaces/forms';

import { GLOBAL_FIELD_NAMES } from 'components/BusinessToolForm/Sections/Global/form';

export interface IOperatingIndustry {
  [GLOBAL_FIELD_NAMES.COMPANY_SECTOR]?: string | IOptionType | null;
  [GLOBAL_FIELD_NAMES.COMPANY_SUB_SECTOR]?: string | IOptionType | null;
  [GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY_GROUP]?: string | IOptionType | null;
  [GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY]?: string | IOptionType | null;
}

export const getOperatingIndustry = (object: IOperatingIndustry) => {
  if (typeof object.companyIndustry === 'object') {
    return object.companyIndustry?.label || '';
  }

  if (typeof object.industryGroup === 'object') {
    return object.industryGroup?.label || '';
  }

  if (typeof object.companySubSector === 'object') {
    return object.companySubSector?.label || '';
  }

  if (typeof object.companySector === 'object') {
    return object.companySector?.label || '';
  }

  return '';
};
